<svg id="menu" fill="currentColor" viewBox="0 0 24 24">
  <rect x="3" y="6" width="18" height="2" rx="1"/>
  <rect x="3" y="11" width="18" height="2" rx="1"/>
  <rect x="3" y="16" width="18" height="2" rx="1"/>
</svg>
